import { pickNewerMobRow } from "@/store/apis/mobsAPI/cellCache"
import { IMobCellResponse } from "@/store/apis/mobsAPI/mobs.types"
import { ICellRef, IMobCellEvent } from "@/store/apis/socketRegistry"

export const isEventOfCell = (event: IMobCellEvent, cell: ICellRef): boolean =>
  event.mapId === cell.mapId && event.x === cell.x && event.y === cell.y

/**
 * Never mutates `entry` (it may be an Immer draft); returns `entry` itself when the
 * event changes nothing, and keeps the untouched rows' objects otherwise.
 */
export const applyMobCellEvent = (
  entry: IMobCellResponse,
  event: IMobCellEvent
): IMobCellResponse => {
  if (event.type === "MOB_CHANGED") {
    const incoming = event.data.mob
    const index = entry.mobs.findIndex((row) => row.id === incoming.id)
    if (index === -1) {
      return { mobs: [...entry.mobs, incoming] }
    }
    const cached = entry.mobs[index]
    if (pickNewerMobRow(cached, incoming) === cached) {
      return entry
    }
    return { mobs: entry.mobs.map((row) => (row === cached ? incoming : row)) }
  }
  if (event.type === "MOB_REMOVED") {
    const removed = entry.mobs.find((row) => row.id === event.data.mobId)
    if (removed === undefined || event.data.version <= removed.version) {
      return entry
    }
    return { mobs: entry.mobs.filter((row) => row !== removed) }
  }
  return entry
}

export const applyMobCellEvents = (
  entry: IMobCellResponse,
  events: IMobCellEvent[]
): IMobCellResponse => events.reduce(applyMobCellEvent, entry)
